import { ErrorMessage } from '@/shared/utils';
import { subscriptionsValidator } from './subscriptions-validator';
import {
  TaskEither,
  Either,
  isLeft,
  left,
  right,
  isRight,
  taskEither,
  fetchData,
} from '@shared-commons/utils';
import { SubscriptionsOptions } from '../types/subscription';
import { subscriptionsAdapter } from './subscriptions-adapter';

export const getSubscriptions = (): TaskEither<Error, SubscriptionsOptions> => {
  const validateSubscriptions = (
    subscriptions: SubscriptionsOptions,
  ): Either<Error, SubscriptionsOptions> => {
    const validatedSubscriptions = subscriptionsValidator(subscriptions);
    if (isLeft(validatedSubscriptions)) {
      const errorMessage = new Error(validatedSubscriptions.value.message);
      return left(new Error(ErrorMessage('Validation error') + errorMessage));
    }
    return right(validatedSubscriptions.value);
  };

  const adapter = (input: SubscriptionsOptions): TaskEither<Error, SubscriptionsOptions> => {
    const adaptTask: TaskEither<Error, SubscriptionsOptions> = async () => {
      try {
        const adaptedSubscriptions = await subscriptionsAdapter(input)();
        if (isRight(adaptedSubscriptions)) {
          return right(adaptedSubscriptions.value);
        } else {
          throw new Error(adaptedSubscriptions.value.message);
        }
      } catch (error) {
        return left(
          new Error(ErrorMessage('Failed to adapt users') + ': ' + (error as Error).message),
        );
      }
    };

    return taskEither(adaptTask);
  };

  return fetchData<SubscriptionsOptions>(
    `${process.env.NEXT_PUBLIC_HOST}/api/profile/subscriptions`,
    (input) => adapter(input),
    validateSubscriptions,
    'GET',
  );
};
